<template>
  <div>
    <b-modal id="modal-maxbet" hide-footer>
      <template v-slot:modal-title>
        {{ $t('content.maxbet.header') }}
      </template>
      <div class="d-block text-center">
        <h5>{{ $t('content.maxbet.content') }}</h5>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  props: {

  },
}
</script>

<style>

</style>
